<div class="inline-block">
  <div #trigger class="inline-block" (click)="openPanel($event)">
    <m-icon-field
      class="block h-8"
      icon="calendar_today"
      iconPosition="right"
      [disabled]="disabled()">
      <span class="b1 text-gray-1000 truncate mr-3">{{ triggerLabel() }}</span>
    </m-icon-field>
  </div>

  <m-overlaypanel
    #panel
    [dismissable]="true"
    customClass="m-compare-period-picker-panel [&_.p-popover-content]:p-0 z-10"
    (panelShow)="alignPanelToTriggerEnd()"
    (panelHide)="onPanelHide()">
    <div class="flex flex-col bg-white rounded-lg min-w-[750px]">
      <div class="flex gap-6 px-3 pt-[12px] border-b border-gray-200">
        @for (tab of tabs(); track tab.value) {
          <button
            type="button"
            class="sh1 pb-2 bg-transparent border-b-2 cursor-pointer"
            [class.text-gray-1000]="activeGranularity() === tab.value"
            [class.border-red-500]="activeGranularity() === tab.value"
            [class.text-gray-800]="activeGranularity() !== tab.value"
            [class.border-transparent]="activeGranularity() !== tab.value"
            (click)="onGranularityChange(tab.value)">
            {{ tab.label }}
          </button>
        }
      </div>

      <div class="flex items-stretch">
        <div class="flex flex-1 min-w-0 flex-col">
          @if (activeGranularity() === "week") {
            <div
              class="p-3 pt-0 flex flex-1 flex-col gap-3"
              [class.pointer-events-none]="!selectionEnabled()"
              [class.opacity-50]="!selectionEnabled()">
              <m-calendar
                class="compare-picker-calendar"
                [inline]="true"
                selectionMode="range"
                resolution="week"
                [numberOfMonths]="1"
                [firstDayOfWeek]="weekStartsOn()"
                [minDate]="currentCalendarMin()"
                [maxDate]="currentCalendarMax()"
                [disabledDates]="weekDisabledDates()"
                [ngModel]="currentWeekDates()"
                (onSelect)="onCurrentWeekSelect($event)">
              </m-calendar>
              <div class="b1 text-gray-800 text-center mt-auto">
                {{ currentLabel() }}
              </div>
            </div>
          } @else if (periodView(); as view) {
            <m-period-picker
              class="flex-1"
              [class.pointer-events-none]="!selectionEnabled()"
              [class.opacity-50]="!selectionEnabled()"
              [view]="view"
              [value]="pendingCurrent()"
              [minDate]="currentMinDate()"
              [maxDate]="currentMaxDate()"
              [allowedPeriods]="allowedPeriods()"
              [footerLabel]="currentLabel()"
              (periodChange)="onCurrentPeriodChange($event)">
            </m-period-picker>
          }
        </div>

        <div class="w-px bg-gray-200 self-stretch"></div>

        <div class="flex flex-1 min-w-0 flex-col">
          @if (activeGranularity() === "week") {
            <div
              class="p-3 pt-0 flex flex-1 flex-col gap-3"
              [class.pointer-events-none]="!selectionEnabled()"
              [class.opacity-50]="!selectionEnabled()">
              <m-calendar
                class="compare-picker-calendar"
                [inline]="true"
                selectionMode="range"
                resolution="week"
                [numberOfMonths]="1"
                [firstDayOfWeek]="weekStartsOn()"
                [minDate]="comparisonCalendarMin()"
                [maxDate]="comparisonCalendarMax()"
                [defaultDate]="comparisonCalendarDefaultDate()"
                [disabledDates]="weekDisabledDates()"
                [ngModel]="comparisonWeekDates()"
                (onSelect)="onComparisonWeekSelect($event)">
              </m-calendar>
              <div class="b1 text-gray-800 text-center mt-auto">
                {{ comparisonLabel() }}
              </div>
            </div>
          } @else if (periodView(); as view) {
            <m-period-picker
              class="flex-1"
              [class.pointer-events-none]="!selectionEnabled()"
              [class.opacity-50]="!selectionEnabled()"
              [view]="view"
              [value]="pendingComparison()"
              [minDate]="comparisonMinDate()"
              [maxDate]="effectiveComparisonMaxDate()"
              [allowedPeriods]="allowedPeriods()"
              [footerLabel]="comparisonLabel()"
              (periodChange)="onComparisonPeriodChange($event)">
            </m-period-picker>
          }
        </div>
      </div>

      <div class="flex justify-end gap-3 px-3 pb-3">
        <m-button type="secondary" (click)="onCancel()">
          <span class="b2">Cancel</span>
        </m-button>
        <m-button type="primary" [disabled]="!canSave()" (click)="onSave()">
          <span class="b2">Save</span>
        </m-button>
      </div>
    </div>
  </m-overlaypanel>
</div>
